import { render, staticRenderFns } from "./appointmentManagement.vue?vue&type=template&id=79367ff8&scoped=true&"
import script from "./appointmentManagement.vue?vue&type=script&lang=js&"
export * from "./appointmentManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79367ff8",
  null
  
)

export default component.exports